import React, { useState, useEffect } from 'react';
import { css } from '@emotion/core';

export function GoToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 200);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    visible && (
      <button onClick={scrollToTop} aria-label='Go to top' css={style}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          fill='currentColor'
          viewBox='0 0 20 20'>
          <path
            fillRule='evenodd'
            d='M10 3a1 1 0 0 1 .707.293l6 6a1 1 0 0 1-1.414 1.414L11 6.414V17a1 1 0 1 1-2 0V6.414L4.707 10.707A1 1 0 0 1 3.293 9.293l6-6A1 1 0 0 1 10 3z'
            clipRule='evenodd'
          />
        </svg>
      </button>
    )
  );
}

const style = css`
  position: fixed;
  bottom: 35px;
  right: 20px;
  padding: 12px;
  border-radius: 50%;
  border: none;
  background-color: #6d3aec;
  color: white;
  font-size: 1.6rem;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease-in-out;
  z-index: 10000;

  /* Move to left on mobile */
  @media (max-width: 992px) {
    right: 85%;
  }
`;
